import { ApolloProvider } from '@apollo/client';
// routes
import Router from 'src/routes/sections';
// theme
import ThemeProvider from 'src/theme';
// hooks
import { useScrollToTop } from 'src/hooks/use-scroll-to-top';
// components
import MotionLazy from 'src/components/animate/motion-lazy';
import ProgressBar from 'src/components/progress-bar';
import { SettingsProvider } from 'src/components/settings';
// auth
import { AuthConsumer, AuthProvider } from 'src/auth/context/amplify';
import { AlertComponent, AlertProvider } from 'src/components/alert';
import SnackbarProvider from 'src/components/snackbar/snackbar-provider';
import apolloClient from 'src/utils/apolloClient';
import { OrganizationContextProvider } from './context/organization';
import { TenantContextProvider } from './context/tenant';

// ----------------------------------------------------------------------

export default function App() {
  useScrollToTop();

  return (
    <ApolloProvider client={apolloClient}>

      <TenantContextProvider>
        <SettingsProvider
          defaultSettings={{
            themeMode: 'light', // 'light' | 'dark'
            themeContrast: 'default', // 'default' | 'bold'
            themeLayout: 'vertical', // 'vertical' | 'horizontal' | 'mini'
            themeColorPresets: 'default', // 'default' | 'cyan' | 'purple' | 'blue' | 'orange' | 'red'
            themeStretch: false,
          }}
        >
          <ThemeProvider>
            <AlertProvider component={AlertComponent}>
              <AuthProvider>
                <MotionLazy>
                  <ProgressBar />
                  <SnackbarProvider>
                    <AuthConsumer>
                      <OrganizationContextProvider>
                        <Router />
                      </OrganizationContextProvider>
                    </AuthConsumer>
                  </SnackbarProvider>
                </MotionLazy>
              </AuthProvider>
            </AlertProvider>
          </ThemeProvider>
        </SettingsProvider>
      </TenantContextProvider>
    </ApolloProvider >
  );
}
